import Handler from "@/core/domain/usecase/handler";

const fetchEquipmentStatusRepository = (axios) => async (pagination) => {
    try {
        const response = await axios.get('/equipment-status', {
            params: pagination
        });

        const equipmentStatusPagination = response.data;
        return equipmentStatusPagination;
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err);
        } else {
            throw err;
        }
    }
}

export default fetchEquipmentStatusRepository